// extracted by mini-css-extract-plugin
export default {"tabularCol":"tabularCol---sctzp tabularCol---GFzAC","cursorNone":"cursorNone---P5Glj"};